exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-39bef767] {\n  font-family: 'Asap regular', Arial, Helvetica, sans-serif;\n  margin: 0px;\n  text-align: right;\n  color: rgba(110, 110, 110, 0.8);\n  font-weight: 500;\n}\n", ""]);

// exports
